import { Form } from "antd";
import styled from "styled-components";
interface StyledFormItemProps {
  lh?: "l1";
  space?: "sp-1";
  hide_error?: boolean;
}
const StyledFormItem = styled(Form.Item)<StyledFormItemProps>`
  margin: 0;

  &.ant-form-item {
    .ant-input-number-outlined.ant-input-number-status-error.ant-input-number-disabled {
      border: 0 !important;
    }
  }
  &.ant-form-item
    .ant-form-item-label
    > label.ant-form-item-required:not(
      .ant-form-item-required-mark-optional
    )::before {
    position: absolute;
    right: 4px;
  }

  ${(props) =>
    props.lh === "l1" &&
    `
      &.ant-form-item .ant-form-item-control-input {
        min-height: 0;
      }
    `}

  ${(props) =>
    props.space === "sp-1" &&
    `
      margin-bottom: var(--space-32);
    `}

  ${(props) =>
    props.hide_error &&
    `
      .ant-form-item-explain-error {
        display: none;
      }
    `}
    ${(props) =>
    props.hide_error &&
    `
      .ant-form-item-explain-error {
        display: none;
      }
    `}
`;

export { StyledFormItem };
